import React, { useState } from 'react'
import { Link, Outlet } from 'react-router-dom';
import { HiMenuAlt3 } from "react-icons/hi"
import { BiCategoryAlt } from "react-icons/bi"
import { MdCategory, MdOutlineBrandingWatermark } from "react-icons/md"
import { AiOutlineClose, AiOutlineHeart, AiOutlineUser } from "react-icons/ai"
import { FiShoppingCart } from "react-icons/fi"
import { GrUnorderedList } from "react-icons/gr"
import { RiSettings4Line } from "react-icons/ri"
const Dashboard = () => {

    const menus = [
        { name: 'Categories', link: '/dashboard/category', icon: BiCategoryAlt },
        { name: 'users', link: '/dashboard/users', icon: AiOutlineUser },
        { name: 'SubCategories', link: '/dashboard/subCategory', icon: MdCategory },
        { name: 'Brands', link: '/dashboard/brand', icon: MdOutlineBrandingWatermark, margin: true },
        { name: 'Orders', link: '/dashboard/orders', icon: GrUnorderedList },
        { name: 'Cart', link: '/dashboard', icon: FiShoppingCart },
        { name: 'Saved', link: '/dashboard', icon: AiOutlineHeart, margin: true },
        { name: 'Setting', link: '/dashboard', icon: RiSettings4Line },
    ]

    const [open, setOpen] = useState(false)

    return (
        <section className="flex gap-6">
            <div className={`bg-[#0e0e0e] min-h-screen ${open ? 'w-72' : 'w-16'} duration-500 text-gray-100 px-4 `}>
                <div className="py-3 flex justify-end ">
                    <div className="cursor-pointer" onClick={() => setOpen(!open)}>
                        {!open ? <HiMenuAlt3 size={20} /> : <AiOutlineClose size={20} />}
                    </div>
                </div>
                <div className="mt-4 flex flex-col gap-4 relative ">
                    {menus?.map((menu, i) => (
                        <Link to={menu?.link} key={i} className={`${menu?.margin && "mt-5"} group flex items-center group text-sm gap-3.5 font-medium p-2 hover:bg-gray-800 rounded-md`}>
                            <div>{React.createElement(menu?.icon, { size: "20" })}</div>
                            <h2 style={{ transitionDelay: `${i + 3}00ms` }} className={`whitespace-pre duration-500 ${!open && 'opacity-0 translate-x-28 overflow-hidden'}`}>{menu?.name}</h2>
                            <h2 className={`${open && 'hidden'} absolute left-48 bg-white font-semibold whitespace-pre text-gray-900 rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-14 group-hover:duration-300 group-hover:w-fit`}>{menu?.name}</h2>
                        </Link>
                    ))}
                </div>
            </div>
            <div className="m-3 w-full">
                <Outlet></Outlet>
            </div>
        </section>
    )
}

export default Dashboard